import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Spin, Col } from 'antd';
import { Formik } from 'formik';
import { Form, Input, Select } from 'formik-antd';
import { useTranslation } from 'react-i18next';
import Box from '~/components/Box';
import Button from '~/components/Button';
import FormControl from '~/components/Form/FormControl';
import Row from '~/components/Row';
import errorHandler from '~/Utils/errorHandler';

const style = {
  btnSubmit: { marginLeft: 10, marginRight: 10, marginTop: 25 },
  btnClear: { marginLeft: 'auto', marginTop: 25 },
};

export default function Filter({ laborTypes, isLoading, setFilters }) {
  const { t } = useTranslation();
  const { Option } = Select;

  const handleSearch = values => {
    if (values.descriptionFilter === '0') {
      values.descriptionFilter = '';
    }
    if (values.laborTypeFilter === '0') {
      values.laborTypeFilter = 'All';
    }
    const filter = [];
    try {
      if (
        values.descriptionFilter !== undefined &&
        values.descriptionFilter !== null &&
        values.descriptionFilter !== ''
      ) {
        filter.push({
          field: 'description',
          value: values.descriptionFilter,
          restriction: 'LIKE',
        });
      }
      if (values.laborTypeFilter !== undefined && values.laborTypeFilter !== null && values.laborTypeFilter !== 'All') {
        filter.push({ columnJoin: 'laborType', field: 'id', value: values.laborTypeFilter, restriction: 'EQUAL' });
      }
      setFilters(filter);
    } catch (error) {
      errorHandler(error);
    }
  };
  return (
    <Box>
      <Formik
        initialValues={{ descriptionFilter: '', laborTypeFilter: 'All' }}
        enableReinitialize
        onSubmit={handleSearch}
      >
        {({ errors, resetForm }) => (
          <Spin spinning={isLoading}>
            <Form>
              <Row>
                <Col span="12">
                  <FormControl
                    error={errors.descriptionFilter}
                    field="descriptionFilter"
                    label={t('screens:estimateDescription.description')}
                  >
                    <Input name="descriptionFilter" placeholder={t('fields:estimateDescription.placeholder')} />
                  </FormControl>
                </Col>
                <Col span="6">
                  <FormControl
                    error={errors.laborTypeFilter}
                    field="laborTypeFilter"
                    label={t('screens:estimateDescription.laborType')}
                  >
                    <Select name="laborTypeFilter">
                      {laborTypes?.map(item => {
                        return (
                          <Option key={item.id} value={item.id.toString()}>
                            {item.code} - {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Col>
                <Button
                  color="default"
                  style={style.btnClear}
                  onClick={() => {
                    resetForm();
                    setFilters([]);
                  }}
                >
                  {t('screens:dateSearch.clearButton')}
                </Button>
                <Button type="submit" color="primary" style={style.btnSubmit}>
                  <SearchOutlined />
                  {t('screens:dateSearch.button')}
                </Button>
              </Row>
            </Form>
          </Spin>
        )}
      </Formik>
    </Box>
  );
}
